<script>
export default {
  name: "ColorInternarRequest",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    const col = context.props.column;
    const val = context.props.row[col];
    const SlaDaysToResponse = context.props.row.SlaDaysToResponse;
    const DiasRetrasadosSla = context.props.row.DiasRetrasadosSla;

    if (DiasRetrasadosSla >= SlaDaysToResponse) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--danger el-tag--plain"
        },
        val
      );
    } else {
      return createElement(
        "span",
        {
          class: "el-tag  el-tag--success el-tag--plain"
        },
        val
      );
    }
  }
};
</script>
